/*
  App
*/
export const TOGGLE_DEVICE = "TOGGLE_DEVICE";

export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";

export const EXPAND_MENU = "EXPAND_MENU";

export const SWITCH_EFFECT = "SWITCH_EFFECT";

/*
 ACCOUNT
*/
export const LOGIN = "LOGIN";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const LOGOUT = "LOGOUT";

export const REGISTER = "REGISTER";

export const REGISTERED = "REGISTERED";

export const SET_ACCOUNT = "SET_ACCOUNT";

export const REFRESH_ACCOUNT = "REFRESH_ACCOUNT";

/*
   Candidate
*/

export const PENDING = "PENDING";
export const SET_CANDIDATE = "SET_CANDIDATE";
export const NEW_CANDIDATE = "NEW_CANDIDATE";
export const DELETE_CANDIDATE = "DELETE_CANDIDATE";
export const SEND_CURRICULUM = "SEND_CURRICULUM";
export const SET_APPLICATION = "SET_APPLICATION";
export const SEND_MOTIVATION = "SEND_MOTIVATION";
export const SEND_DOCUMENT = "SEND_DOCUMENT";
export const SEND_PROCESS_MODE = "SEND_PROCESS_MODE";
export const INTERVIEW_APPOINTMENT = "INTERVIEW_APPOINTMENT";
export const SEND_PAYMENT_MODE = "SEND_PAYMENT_MODE";
export const RECEIVED_PAYMENT = "RECEIVED_PAYMENT";
export const RECEIVED_REGISTRATION = "RECEIVED_REGISTRATION";
export const UPDATE_REGISTRATION = "UPDATE_REGISTRATION";
export const ACCEPT_APPLICATION = "ACCEPT_APPLICATION";
export const CHECKOUT = "CHECKOUT";
export const RESET_CANDIDATE = "RESET_CANDIDATE";
export const SEND_COMMENT = "SEND_COMMENT";
export const UPDATE_COMMENT = "UPDATE_COMMENT";
export const DELETE_COMMENT = "DELETE_COMMENT";
export const FETCH_COMMENTS = "FETCH_COMMENTS";
export const SET_TIMELINE = "SET_TIMELINE";
export const APPEND_TIMELINE = "APPEND_TIMELINE";
export const APPEND_TIMELINE_ITEM = "APPEND_TIMELINE_ITEM";
export const SET_TIMELINE_LOADING = "SET_TIMELINE_LOADING";
export const SET_TIMELINE_INCLUDE_PASSIVE = "SET_TIMELINE_INCLUDE_PASSIVE";
export const RESET_TIMELINE = "RESET_TIMELINE";
export const CANDIDATE_EVENT = "CANDIDATE_EVENT";
export const FETCH_CANDIDATE_EVENTS = "FETCH_CANDIDATE_EVENTS";
export const FETCH_CANDIDATE_DOCUMENTS = "FETCH_CANDIDATE_DOCUMENTS";
export const SET_CANDIDATE_DOCUMENTS = "SET_CANDIDATE_DOCUMENTS";
export const ADD_CANDIDATE_DOCUMENT = "ADD_CANDIDATE_DOCUMENT";
export const REMOVE_CANDIDATE_DOCUMENT = "REMOVE_CANDIDATE_DOCUMENT";
export const SAVING_ACCOUNT = "SAVING_ACCOUNT";
export const SAVED_ACCOUNT = "SAVED_ACCOUNT";
export const ACCOUNT_MSG = "ACCOUNT_MSG";

/*
 IMPERSONATION
*/
export const START_IMPERSONATION = "START_IMPERSONATION";

export const STOP_IMPERSONATION = "STOP_IMPERSONATION";

export const SET_IMPERSONATION_STATUS = "SET_IMPERSONATION_STATUS";
export const SET_CHOICES = "SET_CHOICES";
export const REMOVE_DOCUMENT = "REMOVE_DOCUMENT";
export const REMOVE_FUNDING_DOCUMENT = "REMOVE_FUNDING_DOCUMENT";
export const UPDATE_APPLICATION = "UPDATE_APPLICATION";
export const UPDATE_APPLICATION_FIELDS = "UPDATE_APPLICATION_FIELDS";
export const UPDATE_CANDIDATE_VISA_VALIDATION = "UPDATE_CANDIDATE_VISA_VALIDATION";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const REPLY_MESSAGE = "REPLY_MESSAGE";

/*
* Trainings
*/
export const FETCH_TRAININGS = "FETCH_TRAININGS";

export const ADD_TRAINING = "ADD_TRAINING";

export const UPDATE_TRAINING = "UPDATE_TRAINING";

export const REMOVE_TRAINING = "REMOVE_TRAINING";

/*
* Training themes
*/
export const FETCH_THEMES = "FETCH_THEMES";

/*
* Schools
*/
export const FETCH_SCHOOLS = "FETCH_SCHOOLS";

export const ADD_SCHOOL = "ADD_SCHOOL";

export const UPDATE_SCHOOL = "UPDATE_SCHOOL";

export const FETCH_SCHOLARYEARS = "FETCH_SCHOLARYEARS";

/*
* Campuses
*/
export const FETCH_CAMPUSES = "FETCH_CAMPUSES";

/*
* Documents
*/
export const FETCH_DOCUMENTS = "FETCH_DOCUMENTS";
/*
* Events
*/
export const FETCH_EVENTS = "FETCH_EVENTS";

export const FETCH_CURRENT_EVENTS = "FETCH_CURRENT_EVENTS";

export const FETCH_EVENT_CATEGORIES = "FETCH_EVENT_CATEGORIES";

export const SELECT_EVENT = "SELECT_EVENT";

export const SELECT_CURRENT_EVENT = "SELECT_CURRENT_EVENT";

export const ADD_EVENT = "ADD_EVENT";

export const UPDATE_EVENT = "UPDATE_EVENT";

export const REMOVE_EVENT = "REMOVE_EVENT";
